jQuery(document).ready(function ($) {
    const scrollLeft = new Swiper('#left-scroll', {
        loop: true,

        freeMode: true,
        freeModeMomentum: false,

        slidesPerView: 2,
        slidesPerGroup: 1,

        spaceBetween: 24,

        centeredSlides: true,

        noSwiping: true,

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        delay: 0,
        speed: 5000,

        grabCursor: true,

        breakpoints: {
            480: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 5
            },
            1024: {
                slidesPerView: 7
            }
        }
    });

    const scrollRight = new Swiper('#right-scroll', {
        loop: true,

        freeMode: true,
        freeModeMomentum: false,

        slidesPerView: 2,
        slidesPerGroup: 1,

        spaceBetween: 24,

        centeredSlides: true,

        reverseDirection: true,

        noSwiping: true,

        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        delay: 0,
        speed: 5000,

        breakpoints: {
            480: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 5
            },
            1024: {
                slidesPerView: 7
            }
        }
    });

    const testimonials = new Swiper('.our-clients__testimonials', {
        loop: true,

        slidesPerView: 1,

        spaceBetween: 52,

        centeredSlides: true,

        reverseDirection: true,

        noSwiping: false,

        grabCursor: true,

        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },

        delay: 8000,
        speed: 500,

        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });
});